import React from 'react';
import { motion } from 'framer-motion';
export function InsideSection() {
  return <section className="w-full bg-bg-primary py-12 md:py-20 px-4" data-id="element-111">
      <div className="max-w-6xl mx-auto" data-id="element-112">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-113">
          {/* Left: Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-114">
            <h2 className="text-2xl md:text-4xl font-bold text-text-primary mb-4 md:mb-6" data-id="element-115">
              Estructura operativa ejecutable
            </h2>

            <p className="text-base md:text-lg text-text-secondary mb-4 md:mb-6 leading-relaxed" data-id="element-116">
              Este ebook está diseñado como un sistema de arquitectura
              empresarial, no como un manual teórico.
            </p>

            <div className="bg-bg-card border border-accent-primary border-opacity-10 rounded-lg p-4 md:p-6 mb-4 md:mb-6" data-id="element-117">
              <h3 className="text-lg md:text-xl font-semibold text-text-primary mb-3 md:mb-4" data-id="element-118">
                Incluye:
              </h3>
              <ul className="space-y-2 md:space-y-3" data-id="element-119">
                <li className="flex items-start" data-id="element-120">
                  <span className="text-accent-primary mr-2 md:mr-3" data-id="element-121">•</span>
                  <span className="text-sm md:text-base text-text-secondary" data-id="element-122">
                    Mapa de Ejecución visual de todo el proceso
                  </span>
                </li>
                <li className="flex items-start" data-id="element-123">
                  <span className="text-accent-primary mr-2 md:mr-3" data-id="element-124">•</span>
                  <span className="text-sm md:text-base text-text-secondary" data-id="element-125">
                    Checklist Maestro para cada etapa
                  </span>
                </li>
                <li className="flex items-start" data-id="element-126">
                  <span className="text-accent-primary mr-2 md:mr-3" data-id="element-127">•</span>
                  <span className="text-sm md:text-base text-text-secondary" data-id="element-128">
                    Sistema Búnker Digital para organizar documentos
                  </span>
                </li>
                <li className="flex items-start" data-id="element-129">
                  <span className="text-accent-primary mr-2 md:mr-3" data-id="element-130">•</span>
                  <span className="text-sm md:text-base text-text-secondary" data-id="element-131">
                    Procesos paso a paso con portales y formularios exactos
                  </span>
                </li>
                <li className="flex items-start" data-id="element-132">
                  <span className="text-accent-primary mr-2 md:mr-3" data-id="element-133">•</span>
                  <span className="text-sm md:text-base text-text-secondary" data-id="element-134">
                    Glosario empresarial de términos clave
                  </span>
                </li>
              </ul>
            </div>

            <p className="text-base md:text-lg text-text-primary font-medium" data-id="element-135">
              Todo organizado en 4 áreas: Legal, Fiscal, Bancaria, Contable.
            </p>
          </motion.div>

          {/* Right: Mockup Image */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-136">
            <img src="https://cdn.magicpatterns.com/uploads/1dfDuu6s9PDNbf6vN1DsHn/_mockup_arquitectura_USA2.png" alt="Vista interior del ebook Arquitectura Empresarial USA" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-137" />
          </motion.div>
        </div>
      </div>
    </section>;
}